export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://staging-api.oyecreators.com',
  websiteUrl: 'https://staging.oyecreators.com',
  oneSignalAppId: 'c059a9cb-40d3-4f77-acaf-7108d7c1d29d',
  googleMapsApiKey: 'AIzaSyBoaNey12RUDNZaEk1U3Ndvc-IM4JJgkOQ'
};
